module.exports = __webpack_public_path__ + "img/YOUSHI (1).a6741007.png";